import GlobalVariables from "../models/globalVariables";

const API_URL = GlobalVariables.getAPIURL();

const Utils = {
    base64ToText: async function (base64, fileType = "pdf") {

        const url = `${API_URL}/document/document/base64-to-text`;
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({base64: base64, fileType: fileType}),
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                return data;
            })
            .catch((error) => {
                console.error("Error:", error);
            });

        return response;
    },
};

export default Utils;
